export const getMediaIdFromUrl = (url: string) =>
  url.match(/[^/?#]+(?=$|[?#])/)?.[0].split('.')[0]

export const getMediaIdFromVideoUrl = (url: string) =>
  url.match(/((?:youtube\.com|youtu\.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)(?<id>[\w-]+)(\S+)?$/)?.groups?.id
